export enum CustomerInfo {
  VIN = 'VIN',
  ZIP = 'ZIP',
  DOB = 'DOB',
  SSN = 'SSN',
  SSN_LAST_6 = 'SSN_LAST_6',
  SSN_LAST_4 = 'SSN_LAST_4',
  PHONE_NUMBER = 'PHONE_NUMBER',
  ACCOUNT_NUMBER = 'ACCOUNT_NUMBER',
  CURRENT_ODOMETER = 'CURRENT_ODOMETER',
  FIRST_NAME = 'FIRST_NAME',
  LAST_NAME = 'LAST_NAME',
}

export enum InstructionType {
  MOBILE_APP = 'MOBILE_APP',
  WEBSITE = 'WEBSITE',
  PHONE = 'PHONE',
}

export enum DigitalPayoffEnum {
  FALSE = 'FALSE',
  ROUTE_ONE = 'ROUTE_ONE',
  DEALER_TRACK = 'DEALER_TRACK',
  DEALER_LOGIN = 'DEALER_LOGIN',
}

export type Option = CustomerInfo[];
export type Options = Option[];

const PayoffMethodTypes = [
  'digital',
  'phone',
  'auto_phone',
  'conference_customer',
  'request_customer_payoff',
  'call_as_tater_finance',
] as const;

export type PayoffMethods = {
  [key in typeof PayoffMethodTypes[number]]?: { value: string; options?: Options };
};

export enum InquiryType {
  ACC = 'ACC',
  SSN = 'SSN',
  VIN = 'VIN',
}

export type Lienholder = {
  id: string;
  slug: string;
  display_name: string;
  logo_url: string;
  probableLienholder?: boolean;
  requirements_to_get_payoff?: {
    options: Options;
    get_payoff_methods: PayoffMethods;
  };
  enabled: boolean;
  is_core: boolean;
  aliases: string[];
};

export type InstructionSet = {
  instructions: Instruction[];
  phone_number: string;
  note: string;
  intro: string;
  type: string;
};

export type Instruction = {
  text: string;
  details: string[];
};
